//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DataTable from '../../general/DataTable';
import moment from 'moment';
export default {
  name: 'SleepTable',
  components: {
    DataTable: DataTable
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  },
  computed: {
    headerDefinition: function headerDefinition() {
      return [{
        name: t('health', 'Asleep'),
        columnId: 'asleep',
        type: 'datetime',
        show: true,
        default: function _default() {
          return moment().format('YYYY-MM-DDTHH:mm');
        }
      }, {
        name: t('health', 'Wakeup'),
        columnId: 'wakeup',
        type: 'datetime',
        show: true,
        default: function _default() {
          return moment().format('YYYY-MM-DDTHH:mm');
        }
      }, {
        name: t('health', 'Duration'),
        columnId: 'duration',
        type: 'calculate',
        show: true,
        calc: function calc(dataset) {
          if (!dataset || !dataset.asleep || !dataset.wakeup) {
            return '';
          }

          var start = moment(dataset.asleep);
          var end = moment(dataset.wakeup);

          if (end > start) {
            var duration = moment.duration(end.diff(start));

            if ('durationWakeups' in dataset && dataset.durationWakeups) {
              duration = duration.subtract(dataset.durationWakeups, 'minutes');

              if (!duration.isValid()) {
                console.debug('duration is not valid', duration);
                return '';
              }
            }

            var text = '';

            if (duration._data.days > 0) {
              text = text + n('health', '%nd ', '%nd ', duration._data.days);
            }

            if (duration._data.hours > 0) {
              text = text + n('health', '%nh ', '%nh ', duration._data.hours);
            }

            if (duration._data.minutes > 0) {
              text = text + n('health', '%nmin ', '%nmin ', duration._data.minutes);
            }

            return text;
          } else {
            // console.debug('error', { start: start, end: end })
            return '';
          }
        }
      }, {
        name: t('health', 'Quality'),
        columnId: 'quality',
        type: 'select',
        show: this.person.sleepColumnQuality,
        options: [{
          id: 0,
          label: t('health', 'Perfect', {})
        }, {
          id: 1,
          label: t('health', 'Fine', {})
        }, {
          id: 2,
          label: t('health', 'Okay', {})
        }, {
          id: 3,
          label: t('health', 'Low', {})
        }, {
          id: 4,
          label: t('health', 'Very low', {})
        }]
      }, {
        name: t('health', 'Counted wakeups'),
        columnId: 'countedWakeups',
        type: 'number',
        show: this.person.sleepColumnWakeups
      }, {
        name: t('health', 'Duration wakeups (minutes)'),
        columnId: 'durationWakeups',
        type: 'number',
        show: this.person.sleepColumnWakeups
      }, {
        name: t('health', 'Comment'),
        columnId: 'comment',
        type: 'longtext',
        show: true,
        placeholder: t('health', 'Give some comment, if you want...', {}),
        maxlength: 1000
      }];
    }
  },
  methods: {
    addItem: function addItem(item) {
      // console.debug('add item', item)
      this.$store.dispatch('sleepDatasetsAppend', item);
    },
    updateItem: function updateItem(item) {
      // console.debug('update item', item)
      this.$store.dispatch('sleepDatasetsUpdate', item);
    },
    deleteItem: function deleteItem(item) {
      // console.debug('delete item', item)
      this.$store.dispatch('sleepDatasetsDelete', item);
    }
  }
};